import { render, staticRenderFns } from "./VideoControllers.vue?vue&type=template&id=25dc776e&"
import script from "./VideoControllers.vue?vue&type=script&lang=js&"
export * from "./VideoControllers.vue?vue&type=script&lang=js&"
import style0 from "./VideoControllers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
